import { Price, TotalPrice } from '@app/entities/price';
import { FlightItem } from '@app/entities/flight-results';

export type AirValidationSector = Readonly<{
  SectorNumber: number;
  TotalDuration: string;
  Flights: AirValidationFlightsSector[];
}>;

export type AirValidationSectorVm = Readonly<{
  FlightItem: FlightItem
}> & AirValidationSector;

export type AirValidationResponseVm = Readonly<{
  TripOption: TripOptionsVm;
}> & AirValidationResponse;

export type TripOptions = Readonly<{
  AdultsFareType: string;
  AdultsFareResidualValue: number;
  AdultsTotalAmount: number;
  AdultsTotalResidualValue: number;
  ChildsFareType: string;
  Sectors: AirValidationSector[];
  Price: Price;
  Provider: string;
  AdultsFareAmount: number;
  ChildsFareAmount: number;
  ChildsFareResidualValue: number;
  ChildsTotalAmount: number;
  ChildsTotalResidualValue: number;
  IsAncillaryEnabled: boolean;
  IsMultiTicket: boolean; 
  InfantsFareAmount: number;
  InfantsFareResidualValue: number;
  InfantsFareType: string;
  InfantsTotalAmount: number;
  InfantsTotalResidualValue: number;
  IsBus: boolean;
  PreferenceOrder: number;
  OptionId?: number;
  TextFare?: string;
  ValidatingCarrier: string;
  UpSellEnabled?: boolean;
  LengthOfStay?: number;
  ProductReference?: string;
  HasPrivateFare: boolean;
  SeatMapAvailable: boolean;
  TTL: string;
  FlightKey: string;
  FlightKeyAdvanced: string;
}>;

export type TripOptionsVm = Readonly<{
  Sectors: AirValidationSectorVm[];
}> & TripOptions;

export type AirValidationFlightsSector = Readonly<{
  DepartureAirport: string;
  DepartureTerminalType?: string;
  ArrivalAirport: string;
  ArrivalTerminalType?: string;
  AvailabilityStatus?: number;
  ClassOfService?: string;
  DepartureDate: string;
  ArrivalDate: string
  AirlineCode: string;
  AirlineConfirmationCode?: string;
  AirlineName: string;
  BaggageRestrictions: string;
  FlightTimeInternal: string;
  GMTDepartureDataTime?: string;
  GMTArrivalDataTime?: string;
  OpAirlineCode: string;
  OpAirlineName: string;
  Number: string;
  Cabin: string;
  Equipment: string;
  NumberOfStops: number;
  TechnicalStopAirport?: string;
  TechnicalStopTime: string;
  FareBasis: string;
  FareFamilies: string;
  FareFamiliesCodes?: string;
  IsConnectionInDifferentAirport?: boolean;
  IsFlown?: boolean;
  HandBaggage?: boolean;
  Seats?: AirValidationSeats[];
}>;

export type AirValidationCondition = Readonly<{
  Id: number;
  AirReservationsId: number;
  Sector: number;
  Flight: string;
  CancellationAllowed: boolean;
  CancellationAllowedAfter: boolean;
  CancellationAmount?: {
    CurrencyCode: string;
    Fare: number;
    Taxes: number
  };
  CancellationAmountAfter?: {
    CurrencyCode: string;
    Fare: number;
    Taxes: number
  };
  ChangesAllowed: boolean;
  ChangesAllowedAfter: boolean;
  ChangesAmount: {
    CurrencyCode: string;
    Fare: number;
    Taxes: number
  };
  ChangesAmountAfter?: {
    CurrencyCode: string;
    Fare: number;
    Taxes: number
  };
  NoShow: number;
  NoShowAfter: number;
  ErrorGettingInformation?: boolean
}>;

export type AirValidationResponse = Readonly<{
  AirFareConditions: AirValidationCondition[];
  Result: AirValidationResultType;
  TripOption: TripOptions;
  ValidateAvailableUntil: string;
  ValidationId?: string;
  ValidateOptionIdAir?: string;
  ValidDocuments?: ValidDocuments[];
}>;

export type AirValidationResponseSimple = Readonly<{
  TripOption: {
    Sectors: AirValidationSector[];
  };
  AirFareConditions: AirValidationCondition[];
}>;

export type AirValidationBySectorResponse = Readonly<{
  AirValidateResponse: AirValidationResponse[];
  TotalPrice: TotalPrice;
  ValidDocuments: ValidDocuments[];
}>;

export type AirValidationResponseError = Readonly<{
  Code: AirValidationResultType
}>;

export type ValidDocuments = Readonly<{
  Id: number;
  Name: string;
  Regex?: string;
  DocumentId: number;
}>;

export type AirValidationSeats = Readonly<{
  PassengerIndex: number;
  SeatNumber: string
}>;

export enum AirValidationResultType {
  Available = 'Available',
  NotAvailable = 'NotAvailable',
  PriceDifferent = 'PriceDifference',
  ErrorServer = 'ErrorServer',
  InvalidToken = 'InvalidToken',
  ValidatePackageGetSearchHotel = 'ValidatePackage-GetSearchHotel',
  InvalidHotelOptionId = 'InvalidHotelOptionId',
  AirValidateFailed = 'AirValidateFailed',
  hotelvalidate = 'hotelvalidate'
}
